<page-header titleText="Documents"></page-header>
<div class="container-fluid page-container">
    <dr-tab
        [dynamicRouterLink]="dynamicRouterLink"
        [formGroup]="formGroup"
        [viewedBy]="'external'"
        [schemaType]="'DocumentCenter'"
        [companyKey]="companyKey"
        [adminMode]="false"
    ></dr-tab>
</div>
